<template>
    <div class="content">
        <div class="build-CURD" style="height: 7vh;position: relative;width: 100%;background:#fff;border-bottom: 1px solid #409EFF;display:flex;align-items: center;padding:0 1vh;">
            <el-page-header @back="goBack" :content="pageTitle"></el-page-header>
            <div style="display:flex;justify-content: space-between;align-items: center;height:100%;padding-left:1vw;">
                <div class="grid-search">
                    <el-input v-model="search.name" placeholder="请输入姓名"  clearable>
                        <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button>
                    </el-input>
                    <!-- <el-date-picker v-model="search.month" @change="doFilter" type="month" value-format="yyyy-MM" placeholder="选择月" style="margin-left:1vw;"></el-date-picker> -->
                </div>
            </div>
        </div>
        <div class="build-table">
            <el-table :data="listData" height="100%" style="width: 100%;" stripe :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                  <a>{{ scope.row.index}}</a>
                </template>
              </el-table-column>
              <el-table-column label="姓名">
                <template slot-scope="scope">
                  <a>{{ scope.row.name}}</a>
                </template>
              </el-table-column>
              <el-table-column label="身份证号">
                <template slot-scope="scope">
                  <span>{{ scope.row.idCard }}</span>
                </template>
              </el-table-column>
              <el-table-column label="劳动合同">
                <template slot-scope="scope">
                  <div @click="exportAgreeCon(scope.row)">
                    <img style="width:32px;height:32px;cursor: pointer;" src="../../../assets/image/agree.png" />
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="合同开始时间" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.contractStartTime }}</span>
                </template>
              </el-table-column>
              <el-table-column label="合同结束时间" sortable width="240" prop="salaryMonth" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.contractEndTime}}</span>
                </template>
              </el-table-column>
              <el-table-column label="合同图片">
                <template slot-scope="scope">
                  <div style="width:100%;display:flex;justify-content: center;" v-if="scope.row.imagePath && scope.row.imagePath!=''">
                    <el-button type="text" @click="showContract(scope.row)">查看合同</el-button>
                  </div>
                  <div v-else style="font-size: 14px;">暂无</div>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
        </div>
        <!-- 查看信息 -->
        <el-dialog
          title="合同图片"
          :visible.sync="imgInfoVis"
          center
          :append-to-body="true"
          :lock-scroll="false"
          width="40%"
        >
          <el-form :model="imgInfo" ref="imgInfo" label-width="100px" :label-position="labelPosition">
            <el-form-item label="合同图片：">
              <div style="width:100%;height:100%;postion:relative;display: flex;flex-wrap: wrap;">
                <div v-for="(item,index) in imgInfo.photoList" :key="index" style="width:10vh;height:10vh;postion:relative;padding:0.5vh;">
                  <el-image v-if="item.srcList.length>0" style="width: 100%; height: 100%" :src="item.icon" :preview-src-list="item.srcList"></el-image>
                  <el-image v-else style="width: 100%; height: 100%;padding:10px;cursor: pointer;" @click="downLoadFun(item)" :src="item.icon"></el-image>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </el-dialog>
    </div>
</template>
<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
    data() {
    return {
      dataTree: [],
      listData: [],
      search: {
        //查询
        name: '',
        projectId: '',
        month: util.myTime.getCurMonth()
      },
      // currentPage: 1,
      // pageSize: 10,
      // totalItems: 0,
      dataText: '数据加载中...',
      pageTitle:'',
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      //图片信息弹出框
      imgInfoVis:false,
      imgInfo:{
        photoList:[]
      },
      labelPosition:'right',
    }
  },
  mounted() {
      var params = this.$route.params
      this.search.projectId = params.id
      this.getData()
      this.getInfo()
  },
  methods: {
    // 搜索数据
    doFilter() {
      this.getData()
    },
    //获取
    getInfo(){
        var that = this
        myHttp.getProjectById({
            id:this.search.projectId
        }).then(function(resp){
            if(resp.data.code=='200'){
                var data = resp.data.data.project
                if(data){
                    that.pageTitle = data.name
                }
            }
        })
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    //监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    // 获取数据
    getData() {
        var that = this
        myHttp.getTeamsPersonContractList({
          teamsId: this.classId,
          // time: this.search.month,
          projectId: this.search.projectId,
          name: this.search.name,
          pageNum:this.currentPage,
          pageSize:this.pageSize
        }).then(
          function(resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.entity.list || []
              for (var i = 0; i < list.length; i++) {
                list[i].index = (that.currentPage-1)*that.pageSize+(i + 1)
                // list[i].imagePath =list[i].imagePath == ''? '': base.httpCtx + list[i].imagePath
              }
              that.listData = list
              that.totalItems = resp.data.data.entity.total || 0
              if (that.listData.length == 0) {
                that.dataText = '暂无数据'
              }
            } else {
              that.$message.error(resp.data.msg)
              that.dataText = '暂无数据'
            }
          },
          function() {
            that.dataText = '服务器繁忙中，请稍后请求'
          }
        )
    },
    
    watchInput(e) {
      this.search.name = e
      this.getData()
    },
    /**
     * 导出合同
     */
    // exportAgree() {
    //   if(!this.classId||this.classId==''){
    //     this.$message.error('请先选择班组！')
    //     return
    //   }
    //   var token = util.session.get('token')
    //   window.open(
    //     myHttp.exportTeamsPersonList +
    //       '?teamsId=' +
    //       this.classId +
    //       '&monthTime=' +
    //       this.search.month +
    //       '&projectId=' +
    //       this.search.projectId +
    //       '&accessToken=' +
    //       token
    //   )
    // },
     /**
      * 导出合同
      */
    exportAgreeCon(row) {
      var token = util.session.get('token')
      window.open(
        myHttp.exportContract +
          '?teamsId=' +
          row.teamsId +
          '&personId=' +
          row.personId +
          '&projectId=' +
          this.search.projectId +
          '&accessToken=' +
          token
        )
    },
    //下载文件
    downLoadFun(row){
      window.open(row.url)
    },
     /**
     * 导入表监听方法
     */
    // personSuccess(res, file) {
    //   if (res.code == '200') {
    //     this.$message.success('上传成功')
    //     console.log(res)
    //     this.imoportVisible = true
    //     this.tableData1 = res.data
    //     this.getData()
    //   } else {
    //     this.$message.error(res.msg)
    //   }
    // },
    //上传合同成功监听方法
    // handleAppSuccess(res, file, opt, id) {
    //   console.log(res, file, opt, id)
    //   if (res.code == '200') {
    //     var path = res.data.saveUrls
    //     this.saveImg(id, path)
    //   } else {
    //     this.$message.error(res.msg)
    //   }
    // },
  
    //保存合同图片信息
    // saveImg(id, path) {
    //   var that = this
    //   myHttp
    //     .saveContractImg({
    //       id: id,
    //       path: path
    //     })
    //     .then(function(resp) {
    //       console.log(resp)
    //       if (resp.data.code == '200') {
    //         that.$message.success('上传成功')
    //         that.getData()
    //       } else {
    //         that.$message.error(resp.msg)
    //       }
    //     })
    // },
    // handleClose1(){
    //   this.imoportVisible=false
    // },

    /**
     * 判断是否展示
     */
    isMenuExit(row){
        var flag = util.common.filterBtnMenu(row)
        return flag
    },

    /**
     * 展示合同
     */
    showContract(row){
      // var that = this
      // window.open(row.imagePath);
      // console.log(row.imagePath)
      this.imgInfoVis = true
      this.imgInfo.photoList = []
      var imagePath = row.imagePath||''
      var objs = imagePath&&imagePath!=''?imagePath.split(','):[]
      for(var i=0;i<objs.length;i++){
        var icon = this.getIcon(objs[i])
        var isImg = base.imgType.indexOf(objs[i].split('.')[1])>-1?true:false
        var obj = {
          uid:i+'',
          icon:icon,
          url:base.httpCtx+objs[i],
          baseUrl:objs[i],
          srcList:isImg?[base.httpCtx+objs[i]]:[]
        }
        this.imgInfo.photoList.push(obj)
      }
    },
    getIcon(url){
      var li = url.split('.')[1]
      var result = ''
      if(base.imgType.indexOf(li)>-1){
        result = base.httpCtx+url
      }else if(base.pdfType.indexOf(li)>-1){
        result = require('../../../assets/image/office/pdf.png')
      }else if(base.zipType.indexOf(li)>-1){
        result = require('../../../assets/image/office/zip.png')
      }else{
        result = require('../../../assets/image/office/undefined.png')
      }
      return result
    },

    //返回
    goBack(){
        this.$router.go(-1)
    },

  }
}
</script>

<style>
  .build-table{
    width: 100%;
    height:calc( 100% - 13vh );
    padding: 1vh;
    position: relative;
    background: #fff;
  }
</style>
<style scoped>
  .content{
    background: #fff;
  }
</style>